.card {
  transition: opacity 0.25s ease-in-out 0.25s;
  aspect-ratio: 159/269;
}

/* override reefer's a.link position so ::after covers the card */
.card .link {
  position: static;
  width: 100%;
}

.link a::after {
  content: '';
  position: absolute;
  inset: 0;
}

/* move reefer's link focus underline to the whole card */
.card .link :focus-visible {
  border-bottom: none;
  outline: none;
}

.card:has(.link :focus-visible) {
  outline: 2px solid var(--colors-primary-main);
  outline-offset: -2px;
}

.card:has(.link:active) {
  background-image: linear-gradient(rgb(0 0 0 / 20%), rgb(0 0 0 / 20%));
}

.addToCart {
  --btn-icon-small-height: 40px;
  --btn-icon-small-padding-x: 0;
  --btn-icon-padding: 0;
  --btn-minimal-inverse-border-color: var(--colors-grays-light);

  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 1;
}

.addToCartIcon {
  width: 20px;
  height: 20px;
}

.imageNotLoaded {
  opacity: 0;
}

.imageSlot {
  flex: 1 1 0;
}

.reviewCount {
  margin-left: 2px;
}

/* maintain 2 line space so it takes full space to prevent image from expanding and breaking alignment */
.twoLineName {
  /* fallback for browsers without lh (safari < 16.4) */
  min-height: calc(2 * var(--typography-line-height-mobile));
  min-height: 2lh;
}

@media all and (--reefer-media-desktop-sm-min) {
  .twoLineName {
    min-height: calc(2 * var(--typography-line-height-desktop));
    min-height: 2lh;
  }
}

/* Hide Review Count in the mid range */
@media all and (--reefer-media-desktop-sm-min) and (--reefer-media-desktop-md-max) {
  .reviewCount {
    display: none;
  }
}

@media all and (--reefer-media-desktop-md-min) {
  .card {
    border-radius: var(--border-radius-lg);
  }

  .name {
    font-size: 16px;
  }
}

/* The compact row. */
@media all and (--reefer-media-desktop-sm-max) {
  .card {
    height: auto;
    width: 100%;
    min-width: 220px;
    flex-direction: row;
    align-items: center;
    aspect-ratio: auto;
    gap: 8px;
    padding: 8px 12px 8px 8px;
  }

  .link {
    flex: 1 1 auto;
    min-width: 0;
  }

  .addToCart {
    right: 12px;
    bottom: auto;
    top: 50%;
    transform: translateY(-50%);
  }

  .besideAddToCart > * {
    padding-right: 48px;
  }

  .imageSlot {
    width: 56px;
    height: 56px;
    flex: 0 0 auto;
    border-radius: 8px;
    position: static;
  }

  .lineage {
    display: none;
  }

  .twoLineName {
    min-height: 0;
  }
}
